import req from 'shared/req';
import {FormFieldError} from 'src/utils/errors/FormFieldError';

export interface AdminCollegeListing {
  _id: string;
  university_id?: string;
  school_stabbr?: string;
  slug: string;
  name: string;
  nickname?: string;
}

export interface AdminCollegeListingChange {
  updated_at: string;
  editor_email: string;
}

export type AdminChangedListing = [AdminCollegeListing, AdminCollegeListingChange];

export interface AdminChangedListingsResponse {
  changedListings: AdminChangedListing[];
  lastUniId: string;
  partnersEditable: boolean;
}

export interface AdminCurrentPartnersResponse {
  currentPartners: AdminCollegeListing[];
  lastUniId: string;
  partnersEditable: boolean;
}

export interface AdminChurnedPartnersResponse {
  churnedPartners: AdminCollegeListing[];
  lastUniId: string;
  partnersEditable: boolean;
}

export interface AdminNonPartnersResponse {
  nonPartnerListings: AdminCollegeListing[];
  partnersEditable: boolean;
}

export default class AdminCollegeListingsService {
  static async fetchChanged(): Promise<AdminChangedListingsResponse> {
    let response;
    try {
      response = await req({url: '/v1/admin/college-listings/changed'});
    } catch (error) {
      throw new FormFieldError(error);
    }
    return response;
  }

  static async fetchCurrentPartners(): Promise<AdminCurrentPartnersResponse> {
    let response;
    try {
      response = await req({url: '/v1/admin/college-listings/current-partners'});
    } catch (error) {
      throw new FormFieldError(error);
    }
    return response;
  }

  static async fetchChurnedPartners(): Promise<AdminChurnedPartnersResponse> {
    let response;
    try {
      response = await req({url: '/v1/admin/college-listings/churned-partners'});
    } catch (error) {
      throw new FormFieldError(error);
    }
    return response;
  }

  static async fetchNonPartners(): Promise<AdminNonPartnersResponse> {
    let response;
    try {
      response = await req({url: '/v1/admin/college-listings/non-partners'});
    } catch (error) {
      throw new FormFieldError(error);
    }
    return response;
  }
}
